import { fetchData } from '../utils/fetchData';
import { RESOURCES, API_BASE_URL } from '../utils/constants/constants';

const RISK_SCORE_TYPES_RESOURCES = RESOURCES.riskScoreTypes;

export default function getRiskScoreTypesActive() {
  const resource = `${API_BASE_URL}${RISK_SCORE_TYPES_RESOURCES.availableRiskScoreTypes}`;
  return fetchData(resource);
}
